import { isExternal, isEmpty } from '../util/helpers'
import * as Cookies from 'js-cookie'

export default {
  init() {
    // JavaScript to be fired on all pages
    const anchors = document.querySelectorAll('a')
    const paragraphs = document.querySelectorAll('p')
    const hamburger = document.querySelector('.nav-control')
    const galleryThumbs = document.querySelectorAll('.gallery-icon')
    const jsPopup = document.querySelector('.js-popup')




    // Handle external urls
    anchors.forEach(anchor => {
      if (isExternal(anchor)) {
        // Define attributes to set
        const attributes = {
          target: '__blank',
          rel: 'noopener',
        }

        // Set attributes
        Object.keys(attributes).forEach(attribute => {
          anchor.setAttribute(attribute, attributes[attribute])
        })
      }
    })

    // Handle empty p tags
    paragraphs.forEach(isEmpty)

    $('.toggle__main--nav').click(function () {
      $(this).toggleClass('activated');
      $('.primary-nav-a').toggleClass('hidden');
    });

    // Handle hamburger toggle
    if (hamburger) {
      hamburger.addEventListener('click', () => {
        document.body.classList.toggle('nav-is-open')
      })
    }

    // Handle dropdowns visibility state
    $(function () {
      var children = $('nav > ul > li > a').filter(function () { return $(this).nextAll().length > 0; });
      $('<span class="drop-menu"><i class="fas fa-angle-down"></i></span>').insertAfter(children);
      $('nav ul .drop-menu').click(function () {
        $(this).toggleClass('activated');
        $(this).next().toggleClass('reveal-menu');
        return false;
      });
    });


    const $body = document.querySelector('body');
    const $navMenu = document.querySelector('nav ul');

    $navMenu.addEventListener('click', function (e) {
      if (e.target.parentElement.classList.contains('menu-item')) {
        $body.classList.remove('nav-is-open');
      }
    });




    // Handle gallery lightbox
    if (galleryThumbs) {
      galleryThumbs.forEach(galleryThumb => {
        const galleryAnchor = galleryThumb.children[0]

        galleryAnchor.setAttribute('data-fancybox', 'gallery')
      })

      $('[data-fancybox]').fancybox()
    }

    // Handle Scroll Class for Header
    $(window).scroll(function () {
      var scrolled = $(this).scrollTop();

      if (scrolled >= 120) {
        $('body').addClass('scrolled');
      } else {
        $('body').removeClass('scrolled');
      }
    });

    if (jsPopup && !Cookies.get('popup')) {
      setTimeout(() => {
        $.fancybox.open({
          autoFocus: false,
          src: '.js-popup',
          type: 'inline',
        })

        Cookies.set('popup', 'true', { expires: 7 })
      }, 5000)
    }

    // Slick Homes for sale gallery
    if ($('.js-carousel-gallery').length) {
      $('.js-carousel-gallery').slick({
        arrows: false,
        dots: false,
        fade: false,
        rows: 0,
        autoplay: true,
        autoplaySpeed: 15000,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    }

    if ($('.js-carousel-nav').length) {
      $('.js-carousel-nav').slick({
        arrows: true,
        asNavFor: '.js-carousel-gallery',
        dots: false,
        focusOnSelect: true,
        rows: 0,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerPadding: '60px',
        nextArrow: '<div class="next mr-15"><i class="fas fa-chevron-right text-white"></i></div>',
        prevArrow: '<div class="prev ml-15"><i class="fas fa-chevron-left text-white"></i></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              centerPadding: '60px',
            },
          },
        ],
      });
    }

    /// Column
    if ($('.col-slider').length) {
      $('.col-slider').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 15000,
        fade: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: '<div class="next"><i class="fal fa-chevron-right"></i></div>',
        prevArrow: '<div class="prev"><i class="fal fa-chevron-left"></i></div>',

        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              centerPadding: '15px',
            },
          },
        ],
      });
    }

    if ($('.col-slider-two').length) {
      $('.col-slider-two').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 15000,
        fade: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: '<div class="next"><i class="fal fa-chevron-right"></i></div>',
        prevArrow: '<div class="prev"><i class="fal fa-chevron-left"></i></div>',

        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              centerPadding: '15px',
            },
          },
        ],
      });
    }

    if ($('.col-slider-three').length) {
      $('.col-slider-three').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 15000,
        fade: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: '<div class="next"><i class="fal fa-chevron-right"></i></div>',
        prevArrow: '<div class="prev"><i class="fal fa-chevron-left"></i></div>',

        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              centerPadding: '15px',
            },
          },
        ],
      });
    }















    //////
    // Forms
    /////

    function convertFormat(userDate) {
      var year = userDate.substring(0, 4);
      var month = userDate.substring(5, 7);
      var day = userDate.substring(8, 10);
      var newDate = month + '/' + day + '/' + year;
      return newDate;
    }

    const forms = document.querySelectorAll('.js-book-resorts');

    // Handle form submission
    if (forms) {
      forms.forEach((form) => {
        form.addEventListener('submit', (e) => {
          e.preventDefault();

          const resort = e.target['resort'].value;
          const checkIn = e.target['check_in'].value;
          const checkOut = e.target['check_out'].value;
          const guests = e.target['guests'].value;


          // remove empty space from resort name
          const resortName = resort.replace(/\s/g, '');

          // make it lowercase
          const resortNameLower = resortName.toLowerCase();

          // Handle Booking
          //
          //
          /// betabookings10.rmscloud.com Booking 
          //
          //

          if (resort === 'durango') {
            let querystr = '?';

            if (checkIn != '') {
              querystr += '&A=' + convertFormat(checkIn);
            }
            if (checkOut != '') {
              querystr += '&D=' + convertFormat(checkOut);
            }
            if (guests != 'Please Select') {
              querystr += '&Ad=' + guests;
            }

            if (String(resort) === 'durango') {
              window.open(
                'https://betabookings10.rmscloud.com/Search/Index/6538/90/' +
                querystr
              );
              return;
            }
          }

          //
          //
          /// bookingsus.newbook.cloud Booking
          //
          //

          if (resort === 'stonehedgeestates') {
            let querystr = '?';

            if (checkIn != '') {
              querystr += '&available_from=' + checkIn;
            }
            if (checkOut != '') {
              querystr += '&available_to=' + checkOut;
            }

            if (guests != 'Please Select') {
              querystr += '&guests=' + guests;
            }

            if (guests == 'Please Select') {
              querystr += '&guests=2';
            }




            if (String(resort) === 'stonehedgeestates') {
              window.open(
                'https://bookingsus.newbook.cloud/stonehedgeestates/index.php?place_booking' +
                querystr
              );
              return;
            }


          }


          if (resort === 'Arizona Village' || resort === 'Grand View Village' || resort === 'Mountain Vista' || resort === 'NorthGate' || resort === 'Sierra Grande' || resort === 'Grand View Village Resort') {
            let querystr = '?';

            if (resort != '') {
              querystr += '&resort=' + resort;
            }

            if (checkIn != '') {
              querystr += '&available_from=' + checkIn;
            }
            if (checkOut != '') {
              querystr += '&available_to=' + checkOut;
            }

            if (guests != 'Please Select') {
              querystr += '&guests=' + guests;
            }

            if (guests == 'Please Select') {
              querystr += '&guests=2';
            }



            //window.open(
            //'/reservations' +
            //  querystr
            //);
            // keep in same window tab 
            window.location.href = '/reservations' + querystr;




            return;
          }



          if (resort === 'Casa Grande East' || resort === 'Plaza Verde') {
            let querystr = '?';

            if (resort != '') {
              querystr += '&resort=' + resort;
            }

            if (checkIn != '') {
              querystr += '&available_from=' + checkIn;
            }
            if (checkOut != '') {
              querystr += '&available_to=' + checkOut;
            }

            if (guests != 'Please Select') {
              querystr += '&guests=' + guests;
            }

            if (guests == 'Please Select') {
              querystr += '&guests=2';
            }
            //window.open(
            //'/reservations' +
            //  querystr
            //);
            // keep in same window tab 
            window.location.href = '/reservations-form' + querystr;
            return;
          }


          //
          //
          /// Campspot Booking
          //
          //

          if (
            resort === 'Please Select' &&
            checkIn === '' &&
            checkOut === '' &&
            guests === 'Please Select'
          ) {
            alert(
              'Please select a resort, check-in date, check-out date and number of guests'
            );
          }

          if (
            resort !== 'Please Select' &&
            checkIn === '' &&
            checkOut === '' &&
            guests === 'Please Select'
          ) {
            window.open('https://www.campspot.com/book/${resortNameLower}');
          }

          if (resort === 'Brazoria Lakes RV Resort') {

            if (checkIn === '' && checkOut === '') {

              window.open(
                'https://www.campspot.com/book/brazoria-lakes-rv-resort'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/brazoria-lakes-rv-resort/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }

          if (resort === 'Admiralty RV Resort') {
            if (checkIn === '' && checkOut === '') {
              window.open(
                'https://www.campspot.com/book/admiralty-rv-esort/'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/admiralty-rv-esort/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }

          if (resort === 'AllStar RV Resort') {
            if (checkIn === '' && checkOut === '') {
              window.open(
                'https://www.campspot.com/book/allstar-rv-resort/'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/allstar-rv-resort/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }

          if (resort === 'Bayou Oaks RV Park') {
            if (checkIn === '' && checkOut === '') {
              window.open(
                'https://www.campspot.com/book/bayou-oaks-rv-park'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/bayou-oaks-rv-park/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }

          if (resort === 'Brazoria RV Park') {
            if (checkIn === '' && checkOut === '') {
              window.open(
                'https://www.campspot.com/book/brazoria-rv-park'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/brazoria-rv-park/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }

          if (resort === 'Eastlake RV Resort') {
            if (checkIn === '' && checkOut === '') {
              window.open(
                'https://www.campspot.com/book/eastlake-rv-resort'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/eastlake-rv-resort/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }

          if (resort === 'Fallbrook RV Resort') {
            if (checkIn === '' && checkOut === '') {
              window.open(
                'https://www.campspot.com/book/lakewood-village-resort'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/fallbrook-rv-resort/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }


          if (resort === 'Greenlake RV Resort') {
            if (checkIn === '' && checkOut === '') {
              window.open(
                'https://www.campspot.com/book/greenlake-rv-resort'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/greenlake-rv-resort/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }


          if (resort === 'Highway 6 RV Resort') {
            if (checkIn === '' && checkOut === '') {
              window.open(
                'https://www.campspot.com/book/highway-6-rv-resort'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/highway-6-rv-resort/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }


          if (resort === 'Lakeview RV Resort') {
            if (checkIn === '' && checkOut === '') {
              window.open(
                'https://www.campspot.com/book/lakeview-rv-resort'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/lakeview-rv-resort/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }


          

          if (resort === 'Mont Belvieu RV Resort') {
            if (checkIn === '' && checkOut === '') {
              window.open(
                'https://www.campspot.com/book/mont-belvieu-rv-resort'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/mont-belvieu-rv-resort/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }



          if (resort === 'Northlake RV Resort') {
            if (checkIn === '' && checkOut === '') {
              window.open(
                'https://www.campspot.com/book/northlake-rv-resort'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/northlake-rv-resort/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }

          if (resort === 'QRV Conroe') {
            if (checkIn === '' && checkOut === '') {
              window.open(
                'https://www.campspot.com/book/qrv-conroe'
              );
            } else {
              window.open(
                `https://www.campspot.com/book/qrv-conroe/search/${checkIn}/${checkOut}/guests0,${guests},0`
              );
            }
          }




          if (
            resort !== 'Please Select' &&
            checkIn !== '' &&
            checkOut !== '' &&
            guests === 'Please Select'
          ) {
            window.open(
              `https://www.campspot.com/book/${resortNameLower}/search/${checkIn}/${checkOut}`
            );
          }
        });
      });
    }



  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js